import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { AuthenticatedUserService } from 'src/app/core/services/authenticated-user/authenticated-user.service';
import { SidenavService } from 'src/app/core/services/sidenav/sidenav.service';
import { TranslationService } from 'src/app/core/services/translation/translation.service';
import { ProfileMenuItems } from '../../../models/profile-menu-items/profile-menu-items';
import { ProfileMenuComponent } from '../../molecules/profile-menu/profile-menu.component';

@Component({
  selector: 'app-user-header',
  templateUrl: './user-header.component.html',
  styleUrls: ['./user-header.component.scss'],
})
/**
 * Logged user header
 */
export class UserHeaderComponent implements OnInit {
  @ViewChild(ProfileMenuComponent) userMenu!: ProfileMenuComponent;

  @Input() profileMenuItems = new ProfileMenuItems();
  @Input() imgSource?: string;
  alt = 'uploaded-image-alt';

  /**
   * @constructor
   */
  constructor(
    private sideNavService: SidenavService,
    private translationService: TranslationService,
    private authenticatedUserService: AuthenticatedUserService
  ) {}

  /**
   * On init
   */
  ngOnInit(): void {
    this.imgSource = this.authenticatedUserService.representative?.picture;
    this.translationService.translateObject(this.profileMenuItems);
    this.translationService.translateString(this.alt).then((translated) => {
      this.alt = translated;
    });
  }

  /**
   * opens/closes side menu
   */
  clickMenu() {
    this.sideNavService.toggle();
  }
}
